import request from '@/api/request';

export function getMaintenances () {
  return request({
    url: '/maintenance/getall',
    method: 'get',
  });
}

export function getMaintenancesByVehicle (vehicleId) {
  return request({
    url: '/maintenance',
    method: 'get',
    params: {
      vehicleId
    }
  });
}

export function createMaintenance (data) {
  return request({
    url: '/maintenance',
    method: 'post',
    data
  });
}

export function updateMaintenance (data) {
  return request({
    url: '/maintenance',
    method: 'put',
    data
  });
}

export function deleteMaintenance (id) {
  return request({
    url: '/maintenance',
    method: 'delete',
    params: {
      id
    }
  });
}

export function executeMaintenance (data) {
  return request({
    url: '/maintenance/execute',
    method: 'post',
    data
  });
}

export function getMaintenanceDetail (id) {
  return request({
    url: '/maintenance/detail',
    method: 'get',
    params: {
      id
    }
  });
}

export function getMaintenanceHistory (vehicleId) {
  return request({
    url: '/maintenance/history',
    method: 'get',
    params: {
      vehicleId
    }
  });
}

export function calculateKmRemain (params) {
  return request({
    url: '/maintenance/caculateKmRemain',
    method: 'get',
    params
  });
}

export function createMaintenanceType (data) {
  return request({
    url: '/maintenance/type',
    method: 'post',
    data
  });
}

export function getMaintenanceTypes (params) {
  return request({
    url: '/maintenance/type',
    method: 'get',
    params
  });
}


// WEBPACK FOOTER //
// ./src/api/maintenance.js